<template>
    <div class="main">
        <div class="main-container">
            <div class="top">
                <div class="top-title">
                    <p>SAVE THE DATE: The 7th International Conference on Aging and Cancer:
                        Targeting Common Drivers of Aging and Cancer</p>
                </div>
                <div class="top-links">
                    <a href="/">Hainan,China</a>
                    <a href="https://www.hainmc.edu.cn/icac/index.htm">International Center for Aging and Cancer
                        (ICAC)</a>
                    <a href="https://www.hainmc.edu.cn/">Hainan Medical University (HNMU), Hainan Academy of Medical
                        Sciences</a>
                    <a href="https://www.rjh.com.cn/2018RJPortal/main/rjsy/index.shtml">Ruijin Hospital Affiliated to
                        Shanghai Jiao Tong University</a>
                    <a href="https://www.waxmancancer.org/">Samuel Waxman Cancer Research Foundation (SWCRF)</a>
                </div>
            </div>
            <div class="main-content">
                <div class="summary">
                    <!-- The 7th International Conference on Aging and Cancer: Targeting Common Drivers of Aging and Cancer
                    will take place in <strong>Haikou, China, on 21-22 November, 2025.</strong> -->
                    The 7th International Conference on Aging and Cancer | November 21-22, 2025 | LIYAN Hall, Hainan Medical University, Haikou, China
                </div>
                <div class="content">
                    <p>Aging represents the major risk factor for cancer, 90% of cancers occur in people over the age of
                        50, and the age of the patient influences every aspect of cancer pathogenesis, from premalignant
                        growths to metastasis, to responses to therapy. The focus of this year's International
                        Conference on Aging and Cancer will be on identifying shared biological mechanisms influencing
                        both conditions, aiming to advance innovative strategies for cancer prevention and treatment
                        tailored to aging populations. This conference will invite internationally renowned experts with
                        important influence in the field of aging and cancer research to speak in the form of "offline &
                        online". </p>
                    <p><strong>About the International Center for Aging and Cancer (ICAC)</strong></p>
                    <p>ICAC was jointly established by the Hainan Medical University, Ruijin Hospital Affiliated to
                        Shanghai Jiaotong University School of Medicine, and the Samuel Waxman Cancer Research
                        Foundation (SWCRF) in 2020. ICAC's mission is to advance the understanding of aging and cancer
                        through innovative laboratory, translational, and clinical research in response to the growing
                        problem of global aging and the high incidence of aging-related cancers. ICAC holds an
                        international conference on aging and cancer annually, bringing together experts from around the
                        world to discuss cutting-edge issues in the field of aging and cancer.</p>
                    <p><strong>Organizers</strong></p>
                    <p>The conference is organized by International Center for Aging and Cancer (ICAC), Hainan Medical
                        University (HNMU), Hainan Academy of Medical Sciences, Ruijin Hospital Affiliated to Shanghai
                        Jiao Tong University, Samuel Waxman Cancer Research Foundation (SWCRF).</p>
                </div>
            </div>

        </div>
    </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()
</script>


<style scoped lang="scss">
@font-face {
    font-family: 'Jost';
    font-style: normal;
    font-display: swap;
    src: url("/public/fonts/92zatbhpnqw73otd4g.woff2") format('woff2');
}

.main {
    padding: 40px 0;
}

.main-container {
    width: 1200px;
    margin: 0 auto;

    .top {
        width: 100%;
        display: flex;
        flex-direction: row;
        padding: 40px 0;
        margin-bottom: 40px;

        .top-title {
            width: 65%;
            font-size: 35px;
            color: #04425c;
            line-height: 1.2;
            font-family: 'Jost', 'Open Sans', sans-serif;
            font-weight: 400;
            border-right: 1px solid #05425C;
        }

        .top-links {
            width: 35%;
            font-size: 14px;
            margin-left: 20px;

            a {
                margin-bottom: 5px;
                display: block;
                text-decoration: none;
                color: #0E74A3;

                &:hover {
                    color: #05425C;
                }
            }
        }
    }

    .main-content {
        max-width: 60%;
        margin: 0 auto;

        .summary {
            font-size: 26px;
            font-family: 'Jost', 'Open Sans', sans-serif;
            line-height: 35px;
            font-weight: 300;
            margin-bottom: 40px;

        }

        .content {
            p {
                font-size: 18px;
                line-height: 30px;
                margin-bottom: 20px;
            }
        }
    }
}
@media (max-width: 768px) {
    .main-container {
        width: 100%;
        padding: 0 20px;

        .top {
            flex-direction: column;
            padding: 20px 0;
            margin-bottom: 20px;

            .top-title {
                width: 100%;
                font-size: 28px;
                margin-bottom: 20px;
                border-right: none;
            }

            .top-links {
                width: 100%;
                font-size: 14px;
                margin-left: 0;
            }
        }

        .main-content {
            max-width: 100%;
        }
    }
}
</style>
